var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c(
        "carousel",
        {
          staticClass: "carousel",
          attrs: {
            "per-page": 1,
            "mouse-drag": false,
            paginationColor: "#F2C0DE",
            paginationActiveColor: "#F2C0DE",
            paginationPadding: 0,
            paginationSize: 5,
            centerMode: true
          },
          on: { "page-change": _vm.handlePageChange }
        },
        _vm._l(_vm.images, function(image, index) {
          return _c(
            "slide",
            {
              key: image.product_id,
              on: {
                "slide-click": function($event) {
                  return _vm.handleImgClick(image, index)
                }
              }
            },
            [
              _vm.featuredOutfit
                ? _c("div", { staticClass: "slide product" }, [
                    _c("img", {
                      ref: "slideImage",
                      refInFor: true,
                      staticClass: "slide-image product",
                      style: { maxHeight: _vm.slideshowHeight },
                      attrs: { src: _vm.apiImageUrl(image.product_image_uri) }
                    })
                  ])
                : _c(
                    "div",
                    { staticClass: "slide", class: { product: _vm.product } },
                    [
                      _vm.product
                        ? _c("img", {
                            ref: "slideImage",
                            refInFor: true,
                            staticClass: "slide-image product",
                            style: { maxHeight: _vm.slideshowHeight },
                            attrs: { src: _vm.apiImageUrl(image) }
                          })
                        : _c("img", {
                            ref: "slideImage",
                            refInFor: true,
                            staticClass: "slide-image",
                            style: { maxHeight: _vm.slideshowHeight },
                            attrs: { src: _vm.imageUrl(image) }
                          })
                    ]
                  )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      !_vm.featuredOutfit
        ? _c("slideshow-zoom", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showZoomModal,
                expression: "showZoomModal"
              }
            ],
            ref: "zoom",
            attrs: {
              images: _vm.zoomImages,
              index: _vm.zoomIndex,
              product: _vm.product
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5da247cc", { render: render, staticRenderFns: staticRenderFns })
  }
}